import React from "react";
import Button from "@mui/material/Button";

import Grid from "@mui/material/Grid";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Typography from "@mui/material/Typography";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import {CircularProgress} from "@mui/material";

export default function DatasetUpload(props) {
    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();
    const [uploadClicked, setUploadClicked] = React.useState(false);

    const handleButtonClick = (event) => {
        // simple method to set variable to true after button click to display Spinner
        setUploadClicked(true);

        // then call actual file upload method
        props.handleFileUpload(event);
    };


    return (
        <Grid container>
            <Grid
                id="file-upload-container"
                container
                spacing={2}
                sx={{paddingTop: theme.spacing(6)}}
            >
                <Grid item xs={4} sx={{"li::marker": {content: '""'}}}>
                    <Typography variant="h5" gutterBottom>
                        {t("fileUpload.Requirements")}
                    </Typography>
                    <br/>
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <b>{t("fileUpload.FileType")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>.csv</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("fileUpload.FileSize")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>Max 1000MB</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("fileUpload.NumberRows")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>Min 20, Max 1 000 000</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("fileUpload.NumberCols")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>Min 3, Max 10 000</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("fileUpload.Encoding")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>{t("fileUpload.EncodingValues")}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("fileUpload.Formatting")}</b>
                            </td>
                            <td>
                                <ul>
                                    <li>-{t("fileUpload.FirstRow")}</li>
                                    <li>-{t("fileUpload.EachCol")}</li>
                                    <li>-{t("fileUpload.MultiIndexing")}</li>
                                </ul>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Grid>
                <Grid item xs={3}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        {!uploadClicked ? (
                            <label htmlFor="contained-button-file">
                                <Button variant="contained" color="primary" component="span">
                                    {t("fileUpload.UploadCSVButton")} &nbsp;
                                    <input
                                        hidden
                                        accept=".csv"
                                        id="contained-button-file"
                                        className="upload-input"
                                        type="file"
                                        onChange={handleButtonClick}
                                    />
                                    <CloudUploadIcon/>
                                </Button>
                            </label>
                            ) : (
                                <div>
                                    <CircularProgress/>
                                    <p>&nbsp;{t("datasetCreator.UploadInProgress")}</p>
                                </div>
                            )}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
